import React from 'react'

import { Box, Flex, Text } from '@chakra-ui/layout'
import { Button } from '@chakra-ui/button'
import { Image } from '@chakra-ui/image'
import { Avatar } from '@chakra-ui/avatar'

import { FaWarehouse } from 'react-icons/fa'

import { useGoogleMap } from '../../../../hooks/useGoogleMap'

import { Parking } from '../../../../@types/entities/entities.types'

type InfoWindowProps = {
  data: Parking
}

export function InfoWindow({ data }: InfoWindowProps) {
  const { selectMarker } = useGoogleMap()

  const photo = React.useMemo(() => {
    const photos = data.parking_photos.find(item => item.is_main)

    return photos?.url
  }, [data])

  return (
    <Flex
      padding="20px"
      width="100%"
      height="100%"
      position="relative"
      zIndex={1}
      alignItems="center"
      justifyContent="center"
    >
      <Box
        borderRadius="8px"
        backgroundColor="rgb(255, 255, 255)"
        boxShadow="rgb(152 152 166 / 20%) 0px 5px 5px -3px, rgb(152 152 166 / 14%) 0px 8px 10px 1px, rgb(152 152 166 / 12%) 0px 3px 14px 2px"
        width="100%"
        maxWidth="400px"
        position="relative"
        opacity="1"
        transition="opacity 1s ease-in-out 0s"
      >
        <Flex direction="row" padding="16px" gap="16px">
          <Button
            background="rgb(255, 255, 255)"
            padding="0px"
            border="0px"
            width="32px"
            height="32px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
            position="absolute"
            top="8px"
            right="8px"
            _hover={{
              background: 'transparent',
              color: 'rgb(107, 107, 120)',
            }}
            onClick={() => selectMarker(null)}
          >
            <Image
              src="https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/close-button.svg"
              width="16px"
              height="16px"
              _hover={{
                fill: 'rgb(107, 107, 120)',
              }}
            />
          </Button>
          <Box
            display={{
              base: 'none',
              notebook: 'flex',
            }}
          >
            <Box width="48px">
              <Flex
                borderRadius="8px"
                backgroundColor="rgb(117, 117, 146)"
                boxShadow="rgb(152 152 166 / 20%) 0px 2px 4px -1px, rgb(152 152 166 / 14%) 0px 4px 5px 0px, rgb(152 152 166 / 12%) 0px 1px 10px 0px"
                width="48px"
                height="48px"
                justifyContent="center"
                overflow="hidden"
              >
                <Image
                  src={data.picture}
                  alt={data.name}
                  background="parkoff.orange.300"
                  width="100%"
                  height="100%"
                />
              </Flex>
            </Box>
          </Box>
          <Flex direction="column" alignItems="flex-start" gap="8px">
            <Flex direction="column" gap="4px">
              <Text
                margin="0px 32px 0px 0px"
                padding="0px"
                fontSize="16px"
                fontWeight="700"
                color="rgb(35, 27, 34)"
              >
                {data.name}
              </Text>
              <Flex alignItems="center" gap="4px">
                <Image
                  src="https://parkoff-prod.s3.us-east-2.amazonaws.com/assets/svg/marker-black.svg"
                  width="16px"
                  height="16px"
                />
                <Text
                  margin="0px"
                  padding="0px"
                  fontSize="14px"
                  lineHeight="20px"
                  fontWeight="500"
                  color="rgb(35, 27, 34)"
                  width="100%"
                >
                  {data.parking_address.full_address}
                </Text>
              </Flex>
              <Text
                margin="0px"
                padding="0px"
                fontSize="14px"
                lineHeight="20px"
                fontWeight="500"
                color="rgb(107, 107, 120)"
              >
                {data.parking_characteristics_formatted}
              </Text>
            </Flex>
          </Flex>
        </Flex>
        <Flex
          justifyContent="center"
          background="rgb(245, 245, 250)"
          borderRadius="0px 0px 8px 8px"
          width="full"
        >
          {photo && (
            <Image
              src={photo}
              height={{
                base: '128px',
                notebook: '221px',
              }}
              maxHeight={{
                base: '128px',
                notebook: '221px',
              }}
              width="100%"
              objectFit="cover"
              borderRadius="0px 0px 8px 8px"
            />
          )}
        </Flex>
      </Box>
    </Flex>
  )
}
